import React from 'react';
export const UrgencyBar: React.FC = () => {
  return <div className="bg-gradient-to-r from-red-dark to-red-main text-white text-center py-3 px-5 text-sm font-sans font-bold tracking-wide sticky top-0 z-[1000] shadow-[0_2px_10px_rgba(0,0,0,0.3)]" data-id="element-268" data-mp="m2f6wkschda7">
      ⚠️ PRECIO DE LANZAMIENTO — Sube{' '}
      <span className="text-gold-main" data-id="element-269" data-mp="32xi4ko5nvprn"></span> cuando termine el
      contador &nbsp;|&nbsp; No vuelve.
    </div>;
};